"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabItem = void 0;
exports.generateEncoreTabId = generateEncoreTabId;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _BrowserDefaultFocusStyleContext = require("../../contexts/BrowserDefaultFocusStyleContext.js");
var _KeyboardDetectionContext = require("../../contexts/KeyboardDetectionContext.js");
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _index = require("../Tabs/index.js");
var _utils = require("../Tabs/utils.js");
var _TabItem = require("./TabItem.js");
var _layoutTheme = require("../../styles/layout-theme.js");
var _excluded = ["value", "children", "iconLeading", "label", "id", "aria-controls", "aria-disabled", "onClick", "onKeyDown", "className"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/* eslint-enable local-rules/document-properties */

function generateEncoreTabId(value) {
  return "".concat(value, "-tab");
}

/**
 * TabItem is a clickable element that controls the visibility of an associated TabPanel.
 *
 * This component is meant to be used in conjunction with the other Tab components. Please refer to {@link https://encore-web.spotify.net/?path=/docs/components-tabs--docs Tabs} for a more complete example.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-tabs-tabitem--docs) |
 * [Encore site](https://encore.spotify.net/web/components/tabs) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/TabItem) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=32966-1431&t=608qKxXhWG8gyhvB-1)
 */
var TabItem = exports.TabItem = /*#__PURE__*/_react["default"].forwardRef(function TabItem(_ref, ref) {
  var value = _ref.value,
    children = _ref.children,
    iconLeading = _ref.iconLeading,
    label = _ref.label,
    id = _ref.id,
    ariaControls = _ref['aria-controls'],
    ariaDisabled = _ref['aria-disabled'],
    onClick = _ref.onClick,
    onKeyDown = _ref.onKeyDown,
    className = _ref.className,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var Icon = iconLeading;
  var _useContext = (0, _react.useContext)(_BrowserDefaultFocusStyleContext.BrowserDefaultFocusStyleContext),
    useBrowserDefaultFocusStyle = _useContext.useBrowserDefaultFocusStyle;
  var _useContext2 = (0, _react.useContext)(_KeyboardDetectionContext.KeyboardDetectionContext),
    isUsingKeyboard = _useContext2.isUsingKeyboard;
  var _useContext3 = (0, _react.useContext)(_index.TabsContext),
    selectedTabItem = _useContext3.selectedTabItem,
    handleClick = _useContext3.handleClick,
    tabItems = _useContext3.tabItems;
  var encoreTabId = generateEncoreTabId(value);
  var isSelected = selectedTabItem === encoreTabId;
  var handleAddingTabItemRef = function handleAddingTabItemRef(node) {
    if (node && tabItems) {
      tabItems.set(encoreTabId, node);
    } else if (tabItems) {
      tabItems["delete"](encoreTabId);
    }
    // Make sure that we are handling the ref passed from the customer
    if (ref) {
      if (typeof ref === 'function') {
        ref(node);
      } else {
        ref.current = node;
      }
    }
  };
  var handleKeyDown = function handleKeyDown(e) {
    // We handle selecting the TabItem in Tabs (this prevents having double events)
    // However, we want to make sure that we are allowing the {Tab} key
    if (e.key === _utils.SPACE || e.key === _utils.ENTER) {
      e.preventDefault();
    }
    if (onKeyDown) {
      onKeyDown(e);
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_TabItem.StyledTabItem, Object.assign({
    ref: handleAddingTabItemRef,
    className: (0, _classnames["default"])((0, _layoutTheme.textClass)('bodySmallBold'), className),
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.TabItem,
    tabIndex: isSelected ? undefined : -1,
    role: "tab",
    type: "button",
    id: id !== null && id !== void 0 ? id : encoreTabId,
    "aria-controls": ariaControls !== null && ariaControls !== void 0 ? ariaControls : "".concat(value, "-panel"),
    "aria-disabled": ariaDisabled,
    $useBrowserDefaultFocusStyle: useBrowserDefaultFocusStyle,
    $isUsingKeyboard: isUsingKeyboard,
    "aria-selected": isSelected,
    onClick: ariaDisabled ? undefined : function (e) {
      return handleClick(e, encoreTabId, onClick);
    },
    onKeyDown: handleKeyDown,
    "data-encore-tab-id": encoreTabId
  }, props), children ? children : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, Icon && /*#__PURE__*/_react["default"].createElement(Icon, {
    size: "small"
  }), label));
});